/**
 * Author: Andrey Morozov
 * Confidential. Proprietary and confidential. Unauthorized copying or distribution is prohibited.
 */

export type CoreOIDCSession = {
  subject: string;
  role: "admin" | "viewer";
  expiresAt: number;
};

/** Fetch the current IAM.Core OIDC browser session from the BFF, or null when unauthenticated. */
export async function fetchCoreSession(fetchImpl: typeof fetch = globalThis.fetch): Promise<CoreOIDCSession | null> {
  const response = await fetchImpl("/v1/auth/session", {
    method: "GET",
    credentials: "same-origin",
    headers: { Accept: "application/json" },
  });
  if (response.status === 401) return null;
  if (!response.ok) throw new Error(`IAM.Core session check failed (${response.status})`);
  const body = await response.json() as { subject?: string; role?: string; expires_at?: string };
  const expiresAt = Date.parse(body.expires_at ?? "");
  if (!body.subject || (body.role !== "admin" && body.role !== "viewer") || !Number.isFinite(expiresAt)) {
    throw new Error("IAM.Core session response is invalid");
  }
  return { subject: body.subject, role: body.role, expiresAt };
}

/** Return the gateway URL that starts the OIDC login redirect. */
export function coreLoginURL(): string {
  return "/v1/auth/sso/start";
}

/** Return the gateway URL that clears the core session / logs out. */
export function coreLogoutURL(): string {
  return "/v1/auth/logout";
}
